var _defs, _path, _path2, _path3, _path4, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119, _text120, _text121, _text122, _text123, _text124, _text125, _text126, _text127, _text128, _text129, _text130, _text131, _text132, _text133, _text134, _text135, _text136, _text137, _text138, _text139, _text140, _text141, _text142, _text143, _text144, _text145, _text146, _text147, _text148, _text149, _text150, _text151, _text152, _text153, _text154, _text155, _text156, _text157, _text158, _text159, _text160, _text161, _text162, _text163, _text164, _text165, _text166, _text167, _text168, _text169, _text170, _text171, _text172, _text173, _text174, _text175, _text176, _text177, _text178, _text179, _text180, _text181, _text182, _text183, _text184, _text185, _text186, _text187, _text188, _text189, _text190, _text191, _text192, _text193, _text194, _text195, _text196, _text197, _text198, _text199, _text200, _text201, _text202, _text203, _text204, _text205, _text206, _text207, _text208, _text209, _text210, _text211, _text212, _text213, _text214, _text215, _text216, _text217, _text218, _text219, _text220, _text221, _text222, _text223, _text224, _text225, _text226, _text227, _text228, _text229, _text230, _text231, _text232, _text233, _text234, _text235, _text236, _text237, _text238, _text239, _text240, _text241, _text242, _text243, _text244, _text245, _text246, _text247, _text248, _text249, _text250, _text251, _text252, _text253, _text254, _text255, _text256, _text257, _text258, _text259, _text260, _text261, _text262, _text263, _text264, _text265, _text266, _text267, _text268, _text269, _text270, _text271, _text272, _text273, _text274, _text275, _text276, _text277, _text278, _text279, _text280, _text281, _text282, _text283, _text284, _text285, _text286, _text287, _text288, _text289, _text290, _text291, _text292, _text293, _text294, _text295, _text296, _text297, _text298, _text299, _text300, _text301, _text302, _text303, _text304, _text305, _text306, _text307, _text308, _text309, _text310, _text311, _text312, _text313, _text314, _text315, _text316, _text317, _text318, _text319, _text320, _text321, _text322, _text323, _text324, _text325, _text326, _text327, _text328, _text329, _text330, _text331, _text332, _text333, _text334, _text335, _text336, _text337, _text338, _text339, _text340, _text341, _text342, _text343, _text344, _text345, _text346, _text347, _text348, _text349, _text350, _text351, _text352, _text353, _text354, _text355, _text356, _text357, _text358, _text359, _text360, _text361, _text362, _text363, _text364, _text365, _text366, _text367, _text368, _text369, _text370, _text371, _text372, _text373, _text374, _text375, _text376, _text377, _text378, _text379, _text380, _text381, _text382, _text383, _text384, _text385, _text386, _text387, _text388, _text389, _text390, _text391, _text392, _text393, _text394, _text395, _text396, _text397, _text398, _text399, _text400, _text401, _text402, _text403, _text404, _text405, _text406, _text407, _text408, _text409, _text410, _text411, _text412, _text413, _text414, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5RearDisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "9b2e405f-d856-4edd-810f-32daa40f3aa9",
    "data-name": "Compass",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crp5_6{stroke:#000;stroke-miterlimit:10;stroke-width:0.5px}.crp5_6{fill:none}.crp5_8{font-size:10px}.crp5_8,.crp5_10{font-family:HelveticaNeue-Roman, Helvetica Neue}.crp5_10{font-size:8px}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "9c50ecf9-8a9c-48cc-996c-555da6ebeb7d",
    cx: -0.81,
    cy: 826.43,
    r: 0.74,
    gradientTransform: "matrix(8.29, 0, 0, -8.29, 308.16, 7267.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 228.44c-106.06 0-192 86-192 192s86 192 192 192 192-86 192-192-85.94-192-192-192zm0 344.08a152 152 0 1 1 152-152 152 152 0 0 1-152 152z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 268.45a152 152 0 1 0 152 152 152 152 0 0 0-152-152zm.14 158.34a4.35 4.35 0 1 1 4.34-4.35 4.34 4.34 0 0 1-4.34 4.35z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.6 420.48h.73a5.72 5.72 0 0 1-5.72 5.73v-.73.74a5.75 5.75 0 0 1-5.74-5.73h.73-.74a5.75 5.75 0 0 1 5.73-5.74v.65-.64.65-.64a5.74 5.74 0 0 1 5.74 5.72h-.71l.7-.05v.05h-.71l.7-.05v.06h-.73l-.74.06v-.06a4.26 4.26 0 0 0-4.26-4.26v-.74.74a4.25 4.25 0 0 0-4.25 4.26h-.68.68-.68.68a4.25 4.25 0 0 0 4.26 4.25 4.25 4.25 0 0 0 4.25-4.26h.74l-.74.06z",
    fill: "url(#9c50ecf9-8a9c-48cc-996c-555da6ebeb7d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_6",
    d: "M297.6 268.45v-4.4M297.6 572.51v4.4M284.41 269.02l-.38-4.38M310.79 571.94l.38 4.38M271.02 270.79l-.77-4.33M324.18 570.17l.77 4.33M257.9 273.73l-1.15-4.25M337.31 567.23l1.14 4.25M245.27 277.74l-1.51-4.13M349.93 563.22l1.52 4.13M233.03 282.85l-1.87-3.99M362.17 558.11l1.87 3.99M221.17 289.06l-2.21-3.8M374.03 551.9l2.21 3.8M210.17 296.11l-2.53-3.6M385.04 544.85l2.52 3.6M199.43 304.39l-2.84-3.35M395.77 536.56l2.84 3.36M189.64 313.44l-3.13-3.09M405.56 527.52l3.13 3.09M180.77 323.2l-3.38-2.81M414.43 517.76l3.38 2.81M172.83 333.62l-3.61-2.52M422.37 507.34l3.61 2.51M165.79 344.73l-3.81-2.19M429.41 496.23l3.81 2.19M159.66 356.56l-3.99-1.85M435.54 484.4l3.99 1.85M154.54 369.02l-4.13-1.49M440.66 471.94l4.13 1.48M150.66 381.47l-4.25-1.13M444.54 459.49l4.25 1.12M147.87 394.16l-4.33-.76M447.33 446.8l4.34.76M146.16 407.14l-4.38-.39M449.04 433.82l4.38.39M294.82 268.48l-.03-1.62M300.38 572.48l.03 1.62M292.18 268.55l-.06-1.62M303.02 572.41l.06 1.62M289.42 268.67l-.08-1.61M305.78 572.29l.09 1.61M286.78 268.84l-.12-1.62M308.42 572.12l.12 1.61M281.44 269.31l-.17-1.61M313.76 571.65l.17 1.6M278.87 269.61l-.19-1.61M316.33 571.35l.2 1.6M276.28 269.95l-.23-1.6M318.92 571.01l.23 1.59M273.44 270.38l-.25-1.59M321.76 570.58l.25 1.59M268.33 271.29l-.31-1.58M326.87 569.67l.31 1.58M265.6 271.86l-.34-1.58M329.6 569.1l.34 1.58M263.01 272.44l-.37-1.58M332.19 568.52l.37 1.57M260.51 273.05l-.4-1.57M334.7 567.91l.39 1.57M255.37 274.43l-.45-1.55M339.83 566.53l.45 1.55M252.88 275.18l-.48-1.55M342.32 565.78l.48 1.55M250.34 275.98l-.5-1.53M344.86 564.98l.5 1.53M247.89 276.81l-.53-1.53M347.31 564.15l.53 1.53M242.83 278.66l-.58-1.51M352.37 562.3l.58 1.51M240.27 279.68l-.61-1.5M354.93 561.28l.61 1.5M237.8 280.7l-.63-1.48M357.4 560.26l.63 1.48M235.43 281.74l-.66-1.47M359.77 559.22l.66 1.47M230.55 284.04l-.72-1.45M364.66 556.92l.71 1.45M228.13 285.25l-.74-1.44M367.07 555.71l.74 1.43M225.96 286.39l-.76-1.43M369.24 554.57l.76 1.42M223.58 287.69l-.78-1.42M371.62 553.27l.79 1.41M218.95 290.37l-.83-1.38M376.25 550.59l.83 1.38M216.74 291.74l-.86-1.37M378.46 549.22l.86 1.37M214.49 293.18l-.88-1.35M380.71 547.78l.89 1.35M212.18 294.71l-.9-1.33M383.02 546.24l.91 1.34M207.87 297.75l-.95-1.3M387.33 543.21l.95 1.3M205.86 299.25l-.98-1.29M389.34 541.71l.98 1.28M203.58 301.01l-1-1.27M391.62 539.95l1 1.27M201.46 302.71l-1.02-1.25M393.74 538.25l1.02 1.25M197.52 306.04l-1.07-1.22M397.68 534.92l1.07 1.21M195.49 307.85l-1.09-1.2M399.72 533.11l1.08 1.2M193.63 309.56l-1.11-1.18M401.57 531.4l1.11 1.18M191.52 311.58l-1.13-1.16M403.68 529.38l1.13 1.16M187.9 315.22l-1.16-1.12M407.3 525.74l1.16 1.12M185.97 317.27l-1.19-1.09M409.23 523.69l1.19 1.09M184.29 319.12l-1.2-1.08M410.91 521.84l1.2 1.08M182.51 321.15l-1.23-1.05M412.7 519.81l1.22 1.05M177.54 327.21l-1.27-.99M417.66 513.75l1.28.99M175.88 329.39l-1.29-.97M419.32 511.57l1.29.97M174.36 331.47l-1.31-.95M420.85 509.49l1.31.95M179.25 325.05l-1.25-1.02M415.95 515.91l1.26 1.01M171.36 335.77l-1.35-.9M423.85 505.19l1.34.9M169.92 337.95l-1.36-.87M425.28 503.01l1.36.87M168.4 340.35l-1.37-.85M426.8 500.61l1.37.85M166.99 342.67l-1.38-.83M428.21 498.29l1.39.83M160.79 354.18l-1.46-.7M434.41 486.78l1.46.7M162.02 351.7l-1.44-.73M433.18 489.26l1.44.73M163.2 349.43l-1.43-.76M432 491.53l1.43.76M164.49 347.03l-1.41-.78M430.71 493.93l1.42.78M158.64 358.81l-1.48-.65M436.56 482.15l1.48.65M157.5 361.45l-1.49-.63M437.7 479.51l1.49.63M156.55 363.75l-1.5-.6M438.65 477.21l1.5.6M155.52 366.4l-1.51-.58M439.69 474.56l1.51.57M153.72 371.39l-1.53-.52M441.49 469.57l1.52.52M152.83 374.06l-1.54-.49M442.37 466.9l1.54.49M152.13 376.29l-1.54-.47M443.07 464.67l1.54.47M151.34 379.01l-1.56-.44M443.87 461.95l1.55.44M150 384.07l-1.57-.39M445.21 456.89l1.56.39M149.42 386.48l-1.57-.36M445.78 454.48l1.57.36M148.79 389.37l-1.58-.33M446.41 451.59l1.58.33M148.26 392.02l-1.59-.3M446.94 448.94l1.59.3M147.45 396.67l-1.6-.25M447.75 444.29l1.6.25M147.05 399.3l-1.6-.22M448.15 441.65l1.6.23M146.71 401.88l-1.6-.19M448.49 439.08l1.6.19M146.4 404.65l-1.61-.17M448.8 436.31l1.61.17M145.97 409.46l-1.61-.12M449.23 431.5l1.61.12M145.77 412.8l-1.62-.08M449.44 428.16l1.61.08M145.68 414.65l-1.61-.06M449.52 426.31l1.61.06M145.59 418.05l-1.61-.03M449.61 422.91l1.62.02M449.63 420.48h4.4M145.57 420.48h-4.4M449.05 407.29l4.39-.38M146.14 433.67l-4.38.38M447.29 393.9l4.33-.77M147.91 447.06l-4.33.77M444.35 380.77l4.25-1.14M150.85 460.19l-4.25 1.14M440.34 368.15l4.13-1.51M154.86 472.81l-4.13 1.52M435.23 355.91l3.98-1.87M159.97 485.05l-3.98 1.87M429.02 344.05l3.8-2.21M166.18 496.91l-3.8 2.21M421.97 333.04l3.6-2.52M173.23 507.92l-3.6 2.52M413.68 322.31l3.36-2.84M181.52 518.65l-3.36 2.84M404.63 312.52l3.1-3.13M190.56 528.44l-3.09 3.13M394.88 303.65l2.81-3.38M200.32 537.31l-2.81 3.38M384.46 295.71l2.51-3.61M210.74 545.25l-2.51 3.61M373.35 288.67l2.19-3.81M221.85 552.29l-2.19 3.81M361.52 282.54l1.85-3.99M233.68 558.42l-1.85 3.99M349.06 277.42l1.48-4.13M246.14 563.54l-1.48 4.13M336.61 273.54l1.13-4.25M258.59 567.42l-1.13 4.25M323.92 270.75l.76-4.33M271.28 570.21l-.76 4.33M310.94 269.04l.39-4.38M284.26 571.92l-.39 4.38M449.6 417.7l1.62-.03M145.6 423.26l-1.62.03M449.53 415.06l1.62-.06M145.67 425.9l-1.62.06M449.41 412.3l1.61-.09M145.79 428.66l-1.61.09M449.24 409.66l1.62-.12M145.96 431.3l-1.61.12M448.77 404.32l1.6-.17M146.43 436.64l-1.6.17M448.47 401.75l1.61-.19M146.73 439.21l-1.6.2M448.13 399.16l1.6-.23M147.07 441.8l-1.6.23M447.7 396.32l1.59-.25M147.5 444.64l-1.59.25M446.79 391.21l1.58-.31M148.42 449.75l-1.59.31M446.22 388.48l1.58-.34M148.98 452.48l-1.58.34M445.64 385.89l1.57-.37M149.56 455.07l-1.57.37M445.03 383.39l1.57-.4M150.17 457.58l-1.57.39M443.65 378.25l1.55-.45M151.55 462.71l-1.55.45M442.9 375.76l1.55-.48M152.3 465.2l-1.55.48M442.1 373.22l1.53-.5M153.1 467.74l-1.53.5M441.27 370.77l1.53-.53M153.93 470.19l-1.53.53M439.42 365.71l1.51-.58M155.78 475.25l-1.51.58M438.4 363.15l1.5-.61M156.8 477.81l-1.5.61M437.37 360.68l1.49-.63M157.83 480.28l-1.49.63M436.34 358.31l1.47-.66M158.86 482.65l-1.47.66M434.04 353.42l1.45-.71M161.16 487.54l-1.45.71M432.83 351.01l1.44-.74M162.37 489.95l-1.43.74M431.69 348.84l1.43-.77M163.51 492.12l-1.42.76M430.39 346.46l1.41-.79M164.81 494.5l-1.41.78M427.71 341.83l1.38-.83M167.5 499.13l-1.39.83M426.34 339.62l1.37-.86M168.86 501.34l-1.37.86M424.9 337.37l1.35-.89M170.3 503.59l-1.35.89M423.37 335.06l1.33-.91M171.84 505.9l-1.34.91M420.33 330.75l1.3-.95M174.87 510.21l-1.3.95M418.83 328.74l1.29-.98M176.37 512.22l-1.28.98M417.07 326.46l1.27-1M178.13 514.5l-1.27 1M415.37 324.34l1.25-1.02M179.83 516.62l-1.25 1.02M412.04 320.4l1.22-1.07M183.16 520.56l-1.21 1.07M410.23 318.36l1.2-1.08M184.97 522.6l-1.2 1.08M408.52 316.51l1.18-1.11M186.68 524.45l-1.18 1.11M406.5 314.4l1.16-1.13M188.7 526.56l-1.16 1.13M402.86 310.78l1.12-1.16M192.34 530.18l-1.12 1.16M400.81 308.85l1.09-1.19M194.39 532.11l-1.09 1.19M398.96 307.17l1.08-1.2M196.24 533.79l-1.08 1.2M396.93 305.39l1.05-1.23M198.27 535.58l-1.05 1.22M390.87 300.42l.99-1.28M204.33 540.54l-.99 1.28M388.69 298.76l.97-1.29M206.51 542.2l-.97 1.29M386.61 297.23l.95-1.31M208.59 543.73l-.95 1.3M393.03 302.13l1.01-1.25M202.17 538.83l-1.01 1.26M382.3 294.23l.91-1.34M212.9 546.73l-.9 1.34M380.12 292.8l.88-1.36M215.08 548.16l-.88 1.36M377.73 291.28l.85-1.37M217.47 549.68l-.85 1.37M375.41 289.87l.83-1.39M219.79 551.09l-.83 1.39M363.9 283.67l.7-1.46M231.3 557.29l-.7 1.46M366.38 284.9l.73-1.44M228.82 556.06l-.73 1.44M368.65 286.08l.76-1.43M226.55 554.88l-.76 1.43M371.04 287.37l.79-1.42M224.16 553.59l-.79 1.42M359.27 281.52l.65-1.48M235.93 559.44l-.65 1.48M356.63 280.38l.63-1.49M238.57 560.58l-.63 1.49M354.33 279.43l.6-1.5M240.87 561.53l-.6 1.5M351.68 278.39l.58-1.51M243.52 562.57l-.57 1.51M346.69 276.6l.52-1.54M248.51 564.37l-.52 1.52M344.02 275.71l.49-1.54M251.18 565.25l-.49 1.54M341.79 275.01l.47-1.54M253.41 565.95l-.47 1.54M339.07 274.22l.44-1.56M256.13 566.75l-.44 1.55M334.01 272.88l.39-1.57M261.19 568.09l-.39 1.56M331.6 272.3l.36-1.57M263.6 568.66l-.36 1.57M328.71 271.67l.33-1.58M266.49 569.29l-.33 1.58M326.06 271.14l.3-1.59M269.14 569.82l-.3 1.59M321.41 270.33l.25-1.6M273.79 570.63l-.25 1.6M318.78 269.93l.22-1.6M276.43 571.03l-.23 1.6M316.2 269.59l.19-1.6M279 571.37l-.19 1.6M313.43 269.28l.17-1.61M281.77 571.68l-.17 1.61M308.62 268.85l.12-1.61M286.58 572.11l-.12 1.61M305.28 268.64l.08-1.61M289.92 572.32l-.08 1.61M303.43 268.56l.06-1.61M291.77 572.4l-.06 1.61M300.03 268.47l.02-1.62M295.17 572.49l-.02 1.61M297.6 240.89v-9.33M297.6 600.07v9.33M282.02 241.57l-.81-9.3M313.18 599.39l.82 9.3M266.2 243.66l-1.63-9.19M329 597.3l1.63 9.19M250.7 247.12l-2.44-9.01M344.5 593.84l2.44 9.01M235.78 251.86l-3.21-8.76M359.42 589.1l3.21 8.76M221.32 257.89l-3.96-8.45M373.88 583.07l3.96 8.45M207.31 265.24l-4.69-8.07M387.89 575.72l4.69 8.07M194.31 273.56l-5.36-7.63M400.89 567.4l5.37 7.63M181.63 283.35l-6.02-7.13M413.57 557.61l6.02 7.13M170.06 294.04l-6.62-6.57M425.14 546.92l6.63 6.57M159.58 305.57l-7.17-5.97M435.62 535.39l7.17 5.97M150.21 317.87l-7.66-5.33M444.99 523.09l7.66 5.33M141.89 330.99l-8.09-4.65M453.31 509.97l8.09 4.65M134.65 344.97l-8.46-3.92M460.55 495.99l8.46 3.92M128.61 359.7l-8.78-3.16M466.59 481.27l8.78 3.15M124.02 374.4l-9.02-2.39M471.18 466.56l9.02 2.39M120.72 389.39l-9.19-1.61M474.48 451.57l9.19 1.61M118.7 404.72l-9.29-.82M476.5 436.24l9.29.82M294.26 237.61l-.11-6.02M300.94 603.35l.11 6.02M291.08 237.69l-.22-6.01M304.12 603.27l.22 6.01M287.76 237.84l-.32-6.01M307.44 603.12l.32 6.01M284.58 238.04l-.43-6M310.62 602.92l.43 6M278.16 238.61l-.64-5.98M317.04 602.35l.64 5.98M275.07 238.97l-.74-5.98M320.13 601.99l.74 5.98M271.95 239.38l-.85-5.96M323.25 601.58l.85 5.96M268.54 239.9l-.96-5.94M326.66 601.06l.96 5.94M262.39 241l-1.16-5.91M332.81 599.96l1.16 5.91M259.1 241.67l-1.27-5.88M336.1 599.29l1.27 5.88M255.98 242.37l-1.36-5.86M339.22 598.59l1.37 5.86M252.97 243.1l-1.47-5.83M342.23 597.86l1.47 5.83M246.8 244.77l-1.68-5.78M348.4 596.19l1.68 5.78M243.79 245.67l-1.77-5.75M351.41 595.29l1.77 5.75M240.74 246.64l-1.87-5.72M354.46 594.32l1.87 5.72M237.79 247.63l-1.97-5.69M357.41 593.33l1.97 5.69M231.71 249.86l-2.17-5.62M363.49 591.1l2.17 5.62M228.62 251.08l-2.27-5.57M366.58 589.88l2.27 5.57M225.66 252.32l-2.37-5.54M369.54 588.64l2.37 5.54M222.81 253.57l-2.47-5.5M372.4 587.39l2.46 5.5M216.93 256.33l-2.66-5.4M378.27 584.63l2.66 5.4M214.02 257.79l-2.75-5.36M381.18 583.17l2.75 5.36M211.41 259.16l-2.84-5.31M383.79 581.8l2.84 5.31M208.55 260.72l-2.93-5.26M386.65 580.24l2.93 5.26M202.98 263.95l-3.11-5.15M392.22 577.01l3.11 5.15M200.32 265.59l-3.2-5.1M394.88 575.37l3.2 5.1M197.61 267.33l-3.29-5.04M397.59 573.63l3.29 5.04M194.84 269.17l-3.39-4.98M400.37 571.79l3.38 4.98M189.65 272.83l-3.55-4.86M405.55 568.13l3.55 4.86M187.22 274.63l-3.63-4.8M407.98 566.33l3.63 4.8M184.49 276.75l-3.73-4.73M410.71 564.21l3.73 4.73M181.94 278.79l-3.81-4.66M413.26 562.17l3.81 4.66M177.19 282.8l-3.96-4.53M418.01 558.16l3.96 4.53M174.75 284.98l-4.05-4.46M420.45 555.98l4.05 4.46M172.51 287.04l-4.11-4.4M422.69 553.92l4.11 4.4M169.98 289.46l-4.2-4.31M425.23 551.5l4.2 4.31M165.62 293.85l-4.34-4.17M429.58 547.12l4.34 4.16M163.3 296.31l-4.42-4.08M431.9 544.65l4.42 4.08M161.28 298.53l-4.48-4.01M433.92 542.43l4.48 4.01M159.13 300.98l-4.56-3.93M436.07 539.98l4.56 3.93M153.16 308.27l-4.76-3.69M442.04 532.69l4.76 3.69M151.16 310.89l-4.82-3.61M444.04 530.07l4.82 3.61M149.33 313.39l-4.88-3.53M445.87 527.57l4.88 3.53M155.22 305.67l-4.69-3.78M439.98 535.29l4.69 3.78M145.72 318.57l-5-3.35M449.48 522.39l5 3.35M143.99 321.19l-5.06-3.26M451.21 519.77l5.06 3.26M142.16 324.08l-5.11-3.18M453.04 516.89l5.11 3.17M140.47 326.87l-5.17-3.08M454.73 514.09l5.17 3.08M133 340.72l-5.41-2.63M462.2 500.24l5.41 2.63M134.49 337.73l-5.37-2.72M460.72 503.23l5.36 2.72M135.9 335l-5.32-2.81M459.3 505.96l5.32 2.81M137.46 332.12l-5.27-2.91M457.75 508.84l5.27 2.91M130.42 346.29l-5.5-2.44M464.78 494.67l5.5 2.44M129.05 349.46l-5.55-2.34M466.15 491.5l5.55 2.34M127.91 352.23l-5.59-2.25M467.29 488.73l5.59 2.25M126.66 355.42l-5.63-2.15M468.54 485.54l5.63 2.15M124.49 361.42l-5.69-1.94M470.71 479.54l5.69 1.94M123.43 364.64l-5.73-1.84M471.77 476.32l5.73 1.84M122.59 367.32l-5.76-1.75M472.61 473.64l5.76 1.75M121.63 370.59l-5.79-1.64M473.57 470.37l5.79 1.64M120.02 376.67l-5.85-1.44M475.18 464.29l5.85 1.44M119.33 379.58l-5.87-1.35M475.87 461.38l5.87 1.35M118.57 383.06l-5.9-1.24M476.63 457.9l5.9 1.24M117.93 386.24l-5.92-1.12M477.27 454.72l5.92 1.12M116.95 391.84l-5.94-.95M478.25 449.12l5.94.95M116.48 395l-5.96-.83M478.72 445.96l5.96.83M116.07 398.11l-5.98-.74M479.13 442.85l5.98.74M115.69 401.43l-5.99-.62M479.51 439.53l5.99.63M115.18 407.22l-6.01-.43M480.02 433.74l6.01.43M114.93 411.24l-6.01-.3M480.27 429.72l6.01.3M114.83 413.47l-6.01-.23M480.37 427.49l6.02.23M114.72 417.56l-6.02-.1M480.48 423.4l6.02.1M477.19 420.48h9.33M118.01 420.48h-9.33M476.51 404.9l9.3-.81M118.69 436.06l-9.3.81M474.42 389.08l9.19-1.63M120.78 451.88l-9.19 1.63M470.96 373.58l9.01-2.44M124.24 467.38l-9.01 2.44M466.22 358.66l8.76-3.21M128.98 482.3l-8.76 3.21M460.19 344.2l8.45-3.96M135.01 496.76l-8.45 3.96M452.84 330.19l8.07-4.69M142.36 510.77l-8.07 4.69M444.52 317.19l7.63-5.36M150.68 523.77l-7.63 5.37M434.73 304.51l7.13-6.02M160.47 536.45l-7.13 6.02M424.04 292.94l6.57-6.62M171.16 548.02l-6.57 6.63M412.51 282.47l5.97-7.18M182.69 558.5l-5.97 7.17M400.21 273.09l5.33-7.66M194.99 567.87l-5.33 7.66M387.09 264.77l4.65-8.09M208.11 576.19l-4.65 8.09M373.11 257.53l3.92-8.46M222.09 583.43l-3.92 8.46M358.38 251.49l3.16-8.78M236.81 589.47l-3.15 8.78M343.68 246.9l2.39-9.02M251.52 594.06l-2.39 9.02M328.69 243.6l1.61-9.19M266.51 597.36l-1.61 9.19M313.36 241.58l.82-9.29M281.84 599.38l-.82 9.3M480.47 417.14l6.02-.11M114.73 423.82l-6.02.11M480.39 413.96l6.01-.22M114.81 427l-6.01.22M480.24 410.64l6.01-.32M114.96 430.32l-6.01.32M480.04 407.46l6-.43M115.16 433.5l-6 .43M479.47 401.04l5.99-.64M115.73 439.92l-5.98.64M479.11 397.95l5.98-.74M116.09 443.01l-5.98.74M478.7 394.83l5.96-.85M116.5 446.13l-5.96.85M478.18 391.42l5.94-.96M117.02 449.54l-5.94.96M477.08 385.27l5.91-1.16M118.12 455.69l-5.91 1.16M476.41 381.98l5.88-1.27M118.79 458.98l-5.88 1.27M475.71 378.86l5.86-1.36M119.49 462.1l-5.86 1.37M474.98 375.85l5.83-1.47M120.22 465.11l-5.83 1.47M473.31 369.68l5.78-1.67M121.89 471.28l-5.78 1.67M472.41 366.67l5.75-1.77M122.79 474.29l-5.75 1.77M471.44 363.62l5.72-1.87M123.76 477.34l-5.72 1.87M470.45 360.67l5.69-1.97M124.75 480.29l-5.69 1.97M468.22 354.59l5.62-2.17M126.98 486.37l-5.62 2.17M467 351.5l5.58-2.27M128.2 489.46l-5.58 2.27M465.76 348.54l5.54-2.37M129.44 492.42l-5.54 2.37M464.51 345.69l5.5-2.47M130.69 495.27l-5.5 2.47M461.75 339.81l5.4-2.66M133.45 501.15l-5.4 2.66M460.29 336.9l5.36-2.75M134.91 504.06l-5.36 2.75M458.92 334.29l5.31-2.84M136.28 506.67l-5.31 2.84M457.36 331.43l5.26-2.93M137.84 509.53l-5.26 2.93M454.13 325.86l5.15-3.11M141.07 515.1l-5.15 3.11M452.49 323.2l5.1-3.2M142.71 517.76l-5.1 3.2M450.75 320.49l5.04-3.29M144.45 520.47l-5.04 3.29M448.91 317.72l4.98-3.39M146.29 523.25l-4.98 3.38M445.25 312.53l4.86-3.55M149.95 528.43l-4.86 3.55M443.45 310.1l4.8-3.63M151.75 530.86l-4.8 3.63M441.33 307.37l4.73-3.72M153.87 533.59l-4.74 3.73M439.29 304.82l4.66-3.81M155.91 536.14l-4.66 3.81M435.28 300.07l4.53-3.96M159.92 540.89l-4.53 3.96M433.1 297.63l4.46-4.05M162.1 543.33l-4.46 4.05M431.04 295.39l4.4-4.11M164.16 545.57l-4.4 4.11M428.62 292.86l4.31-4.2M166.58 548.11l-4.31 4.2M424.24 288.51l4.16-4.35M170.96 552.46l-4.16 4.34M421.77 286.18l4.08-4.42M173.43 554.78l-4.08 4.42M419.55 284.16l4.01-4.48M175.65 556.8l-4.01 4.48M417.1 282.01l3.93-4.56M178.1 558.95l-3.93 4.56M409.81 276.04l3.69-4.76M185.39 564.92l-3.69 4.76M407.19 274.04l3.61-4.82M188.01 566.92l-3.61 4.82M404.69 272.21l3.53-4.88M190.51 568.76l-3.53 4.87M412.41 278.1l3.78-4.69M182.79 562.86l-3.78 4.69M399.51 268.6l3.35-5M195.69 572.36l-3.35 5M396.89 266.87l3.26-5.06M198.31 574.09l-3.26 5.06M394 265.05l3.18-5.12M201.19 575.92l-3.17 5.11M391.21 263.35l3.08-5.17M203.99 577.61l-3.08 5.17M377.36 255.88l2.63-5.41M217.84 585.08l-2.63 5.41M380.35 257.37l2.72-5.37M214.85 583.6l-2.72 5.36M383.08 258.78l2.82-5.32M212.12 582.18l-2.82 5.32M385.96 260.34l2.91-5.27M209.24 580.62l-2.91 5.28M371.79 253.3l2.44-5.5M223.41 587.66l-2.44 5.5M368.62 251.93l2.34-5.55M226.58 589.03l-2.34 5.55M365.85 250.79l2.25-5.59M229.35 590.17l-2.25 5.59M362.66 249.54l2.14-5.63M232.54 591.42l-2.15 5.63M356.66 247.37l1.95-5.69M238.54 593.59l-1.95 5.69M353.44 246.31l1.84-5.73M241.76 594.65l-1.84 5.73M350.76 245.47l1.75-5.76M244.44 595.49l-1.75 5.76M347.49 244.51l1.64-5.79M247.71 596.45l-1.64 5.79M341.41 242.9l1.44-5.84M253.79 598.06l-1.44 5.85M338.5 242.21l1.35-5.87M256.7 598.75l-1.35 5.87M335.03 241.45l1.23-5.9M260.17 599.52l-1.23 5.89M331.84 240.81l1.12-5.91M263.36 600.15l-1.12 5.92M326.24 239.83l.95-5.94M268.96 601.13l-.95 5.94M323.08 239.36l.83-5.96M272.12 601.6l-.83 5.96M319.97 238.95l.74-5.97M275.23 602.01l-.74 5.98M316.65 238.57l.63-5.99M278.55 602.39l-.63 5.99M310.86 238.06l.43-6.01M284.34 602.9l-.43 6.01M306.84 237.81l.3-6.01M288.36 603.15l-.31 6.01M303.42 237.67l.19-6.02M291.78 603.29l-.19 6.02M300.52 237.6l.1-6.02M294.68 603.36l-.1 6.02"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(1, -0.02, 0.02, 1, 294.43, 250.8)"
  }, "0")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(299.96 249.76) rotate(1.24)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(302.72 249.82) rotate(2.15)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(305.49 249.92) rotate(3.07)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(308.26 250.07) rotate(3.99)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(1, 0.09, -0.09, 1, 311.01, 250.26)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(313.77 250.5) rotate(5.83)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.99, 0.12, -0.12, 0.99, 316.53, 250.78)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(319.27 251.11) rotate(7.68)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 322, 251.47)"
  }, "1")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.98, 0.18, -0.18, 0.98, 326.39, 252.15)"
  }, "0")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(330.74 252.96) rotate(11.6)"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(333.38 253.5) rotate(12.51)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(335.98 254.08) rotate(13.41)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(338.58 254.7) rotate(14.31)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(341.19 255.36) rotate(15.22)"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 343.76, 256.06)"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(346.32 256.8) rotate(17.02)"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(348.89 257.58) rotate(17.93)"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(351.43 258.4) rotate(19.12)"
  }, "2")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.94, 0.35, -0.35, 0.94, 355.63, 259.85)"
  }, "0")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(359.76 261.41) rotate(21.83)"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(362.27 262.42) rotate(22.74)"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(364.72 263.44) rotate(23.64)"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(367.19 264.52) rotate(24.55)"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(369.6 265.63) rotate(25.44)"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.9, 0.44, -0.44, 0.9, 372.03, 266.78)"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(374.44 267.97) rotate(27.25)"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(376.82 269.2) rotate(28.15)"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(379.17 270.45) rotate(29.33)"
  }, "3")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.86, 0.51, -0.51, 0.86, 383.03, 272.61)"
  }, "0")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.85, 0.53, -0.53, 0.85, 386.84, 274.9)"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.84, 0.54, -0.54, 0.84, 389.1, 276.31)"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(391.34 277.76) rotate(33.82)"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(393.58 279.26) rotate(34.72)"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(395.77 280.78) rotate(35.61)"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.8, 0.59, -0.59, 0.8, 397.96, 282.34)"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.79, 0.61, -0.61, 0.79, 400.1, 283.93)"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.78, 0.62, -0.62, 0.78, 402.24, 285.56)"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(404.33 287.2) rotate(39.47)"
  }, "4")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(407.75 290.01) rotate(40.94)"
  }, "0")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(411.1 292.93) rotate(42.15)"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(413 294.65) rotate(43)"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(414.88 296.4) rotate(43.86)"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(416.75 298.19) rotate(44.72)"
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(418.57 299.99) rotate(45.58)"
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(420.36 301.82) rotate(46.43)"
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(422.13 303.67) rotate(47.28)"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(423.89 305.58) rotate(48.15)"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(425.6 307.48) rotate(49.28)"
  }, "5")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(428.48 310.83) rotate(50.76)"
  }, "0")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.62, 0.79, -0.79, 0.62, 431.28, 314.26)"
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(432.94 316.38) rotate(52.85)"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.59, 0.81, -0.81, 0.59, 434.54, 318.5)"
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(436.14 320.67) rotate(54.65)"
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(437.68 322.84) rotate(55.54)"
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(439.21 325.07) rotate(56.44)"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(440.68 327.29) rotate(57.34)"
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.53, 0.85, -0.85, 0.53, 442.12, 329.53)"
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.51, 0.86, -0.86, 0.51, 443.54, 331.8)"
  }, "6")), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(445.8 335.63) rotate(60.9)"
  }, "0")), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.47, 0.88, -0.88, 0.47, 447.94, 339.49)"
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(449.2 341.86) rotate(63.01)"
  })), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(450.41 344.25) rotate(63.91)"
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(451.58 346.64) rotate(64.81)"
  })), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(452.73 349.07) rotate(65.72)"
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(453.84 351.52) rotate(66.62)"
  })), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(454.89 353.97) rotate(67.52)"
  })), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.91 356.43) rotate(68.42)"
  })), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.35, 0.94, -0.94, 0.35, 456.91, 358.93)"
  }, "7")), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(458.45 363.06) rotate(71.1)"
  }, "0")), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(459.88 367.26) rotate(72.32)"
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(460.67 369.73) rotate(73.2)"
  })), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(461.41 372.18) rotate(74.07)"
  })), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(462.11 374.65) rotate(74.94)"
  })), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(462.78 377.12) rotate(75.8)"
  })), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(463.41 379.6) rotate(76.67)"
  })), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(464.01 382.12) rotate(77.54)"
  })), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(464.56 384.61) rotate(78.4)"
  })), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(465.09 387.12) rotate(79.55)"
  }, "8")), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(465.89 391.49) rotate(81.04)"
  }, "0")), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(466.57 395.86) rotate(82.25)"
  })), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(466.92 398.39) rotate(83.11)"
  })), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(467.23 400.94) rotate(83.96)"
  })), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.09, 1, -1, 0.09, 467.5, 403.49)"
  })), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(467.73 406.06) rotate(85.68)"
  })), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.06, 1, -1, 0.06, 467.93, 408.62)"
  })), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.05, 1, -1, 0.05, 468.09, 411.19)"
  })), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.03, 1, -1, 0.03, 468.21, 413.76)"
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(468.28 416.32) rotate(89.07)"
  }, "9")), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(468.35 420.74) rotate(90.93)"
  }, "0")), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.04, 1, -1, -0.04, 468.27, 425.18)"
  })), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(468.18 427.74) rotate(92.86)"
  })), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(468.06 430.3) rotate(93.71)"
  })), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(467.89 432.87) rotate(94.57)"
  })), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.09, 1, -1, -0.09, 467.69, 435.44)"
  })), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(467.45 438) rotate(96.28)"
  })), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.12, 0.99, -0.99, -0.12, 467.17, 440.54)"
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.14, 0.99, -0.99, -0.14, 466.86, 443.08)"
  }, "1")), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.17, 0.99, -0.99, -0.17, 466.23, 447.46)"
  }, "0")), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(465.47 451.83) rotate(101.26)"
  }, "0")), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(464.6 456.16) rotate(102.47)"
  })), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(464.04 458.68) rotate(103.35)"
  })), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(463.45 461.19) rotate(104.22)"
  })), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(462.83 463.65) rotate(105.07)"
  })), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(462.16 466.13) rotate(105.94)"
  })), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(461.45 468.62) rotate(106.82)"
  })), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.3, 0.95, -0.95, -0.3, 460.71, 471.08)"
  })), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(459.94 473.53) rotate(108.84)"
  }, "1")), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.35, 0.94, -0.94, -0.35, 458.52, 477.71)"
  }, "1")), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(456.98 481.86) rotate(111.83)"
  }, "0")), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.32 485.99) rotate(113.05)"
  })), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(454.31 488.34) rotate(113.91)"
  })), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(453.28 490.69) rotate(114.78)"
  })), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(452.21 493.01) rotate(115.64)"
  })), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.45, 0.89, -0.89, -0.45, 451.09, 495.34)"
  })), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(449.95 497.63) rotate(117.37)"
  })), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(448.78 499.91) rotate(118.51)"
  }, "1")), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(446.66 503.81) rotate(120.01)"
  }, "2")), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.52, 0.85, -0.85, -0.52, 444.46, 507.63)"
  }, "0")), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.54, 0.84, -0.84, -0.54, 442.13, 511.41)"
  })), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.55, 0.83, -0.83, -0.55, 440.74, 513.58)"
  })), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(439.32 515.72) rotate(124.42)"
  })), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(437.87 517.84) rotate(125.28)"
  })), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(436.39 519.93) rotate(126.14)"
  })), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(434.88 522.01) rotate(126.99)"
  })), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.62, 0.79, -0.79, -0.62, 433.35, 524.06)"
  }, "1")), _text128 || (_text128 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.64, 0.77, -0.77, -0.64, 430.62, 527.54)"
  }, "3")), _text129 || (_text129 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(427.78 530.97) rotate(131.09)"
  }, "0")), _text130 || (_text130 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.67, 0.74, -0.74, -0.67, 424.87, 534.29)"
  })), _text131 || (_text131 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(423.23 536.09) rotate(133.1)"
  })), _text132 || (_text132 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.69, 0.72, -0.72, -0.69, 421.57, 537.87)"
  })), _text133 || (_text133 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.7, 0.71, -0.71, -0.7, 419.87, 539.65)"
  })), _text134 || (_text134 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(418.16 541.38) rotate(135.54)"
  })), _text135 || (_text135 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.72, 0.69, -0.69, -0.72, 416.42, 543.08)"
  })), _text136 || (_text136 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.73, 0.68, -0.68, -0.73, 414.66, 544.76)"
  })), _text137 || (_text137 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(412.89 546.43) rotate(138.26)"
  }, "1")), _text138 || (_text138 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.76, 0.65, -0.65, -0.76, 409.57, 549.39)"
  }, "4")), _text139 || (_text139 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(406.19 552.25) rotate(141.22)"
  }, "0")), _text140 || (_text140 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(402.74 555.01) rotate(142.42)"
  })), _text141 || (_text141 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.8, 0.6, -0.6, -0.8, 400.71, 556.57)"
  })), _text142 || (_text142 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.81, 0.59, -0.59, -0.81, 398.65, 558.11)"
  })), _text143 || (_text143 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.82, 0.57, -0.57, -0.82, 396.58, 559.62)"
  })), _text144 || (_text144 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(394.47 561.09) rotate(145.85)"
  })), _text145 || (_text145 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.84, 0.55, -0.55, -0.84, 392.35, 562.53)"
  })), _text146 || (_text146 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.85, 0.53, -0.53, -0.85, 390.2, 563.95)"
  }, "1")), _text147 || (_text147 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(386.46 566.31) rotate(149.34)"
  }, "5")), _text148 || (_text148 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.87, 0.49, -0.49, -0.87, 382.65, 568.57)"
  }, "0")), _text149 || (_text149 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.88, 0.47, -0.47, -0.88, 378.79, 570.71)"
  })), _text150 || (_text150 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(376.5 571.93) rotate(152.9)"
  })), _text151 || (_text151 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.9, 0.44, -0.44, -0.9, 374.23, 573.09)"
  })), _text152 || (_text152 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.9, 0.43, -0.43, -0.9, 371.91, 574.24)"
  })), _text153 || (_text153 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(369.6 575.34) rotate(155.5)"
  })), _text154 || (_text154 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(367.27 576.4) rotate(156.36)"
  })), _text155 || (_text155 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(364.92 577.43) rotate(157.23)"
  })), _text156 || (_text156 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.93, 0.37, -0.37, -0.93, 362.54, 578.44)"
  }, "1")), _text157 || (_text157 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(358.42 580.07) rotate(159.88)"
  }, "6")), _text158 || (_text158 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(354.28 581.59) rotate(161.37)"
  }, "0")), _text159 || (_text159 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.95, 0.3, -0.3, -0.95, 350.07, 583)"
  })), _text160 || (_text160 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.96, 0.28, -0.28, -0.96, 347.63, 583.77)"
  })), _text161 || (_text161 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.96, 0.27, -0.27, -0.96, 345.17, 584.5)"
  })), _text162 || (_text162 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(342.7 585.2) rotate(165.19)"
  })), _text163 || (_text163 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(340.21 585.86) rotate(166.06)"
  })), _text164 || (_text164 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(337.74 586.47) rotate(166.92)"
  })), _text165 || (_text165 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(335.23 587.07) rotate(168.08)"
  }, "1")), _text166 || (_text166 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(330.89 587.98) rotate(169.57)"
  }, "7")), _text167 || (_text167 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(326.52 588.78) rotate(171.07)"
  }, "0")), _text168 || (_text168 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(322.15 589.46) rotate(172.27)"
  })), _text169 || (_text169 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(319.62 589.81) rotate(173.13)"
  })), _text170 || (_text170 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.99, 0.1, -0.1, -0.99, 317.08, 590.12)"
  })), _text171 || (_text171 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(314.52 590.39) rotate(174.85)"
  })), _text172 || (_text172 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, 0.07, -0.07, -1, 311.95, 590.62)"
  })), _text173 || (_text173 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, 0.06, -0.06, -1, 309.41, 590.81)"
  })), _text174 || (_text174 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(306.82 590.97) rotate(177.41)"
  })), _text175 || (_text175 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(304.26 591.1) rotate(178.54)"
  }, "1")), _text176 || (_text176 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(299.81 591.25) rotate(-179.07)"
  }, "8")), _text177 || (_text177 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(295.42 591.21) rotate(-178.55)"
  }, "0")), _text178 || (_text178 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, -0.05, 0.05, -1, 290.99, 591.09)"
  })), _text179 || (_text179 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, -0.06, 0.06, -1, 288.43, 590.97)"
  })), _text180 || (_text180 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(285.85 590.82) rotate(-175.65)"
  })), _text181 || (_text181 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, -0.09, 0.09, -1, 283.28, 590.62)"
  })), _text182 || (_text182 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(280.72 590.39) rotate(-173.93)"
  })), _text183 || (_text183 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(278.17 590.12) rotate(-173.07)"
  })), _text184 || (_text184 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.99, -0.14, 0.14, -0.99, 275.63, 589.82)"
  }, "1")), _text185 || (_text185 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(271.25 589.2) rotate(-170.45)"
  }, "9")), _text186 || (_text186 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(266.88 588.47) rotate(-168.95)"
  }, "0")), _text187 || (_text187 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(262.54 587.61) rotate(-167.74)"
  })), _text188 || (_text188 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(260.04 587.07) rotate(-166.88)"
  })), _text189 || (_text189 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(257.53 586.49) rotate(-166.01)"
  })), _text190 || (_text190 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(255.03 585.87) rotate(-165.14)"
  })), _text191 || (_text191 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(252.55 585.21) rotate(-164.27)"
  })), _text192 || (_text192 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(250.08 584.51) rotate(-163.4)"
  })), _text193 || (_text193 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(247.62 583.78) rotate(-162.53)"
  })), _text194 || (_text194 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.95, -0.32, 0.32, -0.95, 245.17, 583.02)"
  }, "2")), _text195 || (_text195 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(240.99 581.61) rotate(-159.89)"
  }, "0")), _text196 || (_text196 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(236.82 580.09) rotate(-158.39)"
  }, "0")), _text197 || (_text197 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(232.69 578.44) rotate(-157.17)"
  })), _text198 || (_text198 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(230.33 577.45) rotate(-156.31)"
  })), _text199 || (_text199 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(227.98 576.42) rotate(-155.44)"
  })), _text200 || (_text200 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(225.65 575.36) rotate(-154.58)"
  })), _text201 || (_text201 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(223.32 574.25) rotate(-153.71)"
  })), _text202 || (_text202 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.89, -0.46, 0.46, -0.89, 221.02, 573.12)"
  })), _text203 || (_text203 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.88, -0.47, 0.47, -0.88, 218.75, 571.96)"
  }, "2")), _text204 || (_text204 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(214.83 569.85) rotate(-150.21)"
  }, "1")), _text205 || (_text205 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(211 567.66) rotate(-148.73)"
  }, "0")), _text206 || (_text206 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.84, -0.54, 0.54, -0.84, 207.21, 565.35)"
  })), _text207 || (_text207 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(205.04 563.97) rotate(-146.66)"
  })), _text208 || (_text208 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.83, -0.56, 0.56, -0.83, 202.89, 562.56)"
  })), _text209 || (_text209 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 200.77, 561.12)"
  })), _text210 || (_text210 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(198.67 559.65) rotate(-144.08)"
  })), _text211 || (_text211 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(196.59 558.14) rotate(-143.22)"
  })), _text212 || (_text212 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(194.53 556.61) rotate(-142.36)"
  })), _text213 || (_text213 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(192.5 555.05) rotate(-141.23)"
  }, "2")), _text214 || (_text214 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(189.05 552.28) rotate(-139.75)"
  }, "2")), _text215 || (_text215 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.75, -0.67, 0.67, -0.75, 185.65, 549.41)"
  }, "0")), _text216 || (_text216 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.73, -0.68, 0.68, -0.73, 182.36, 546.46)"
  })), _text217 || (_text217 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.72, -0.69, 0.69, -0.72, 180.49, 544.72)"
  })), _text218 || (_text218 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(178.61 542.93) rotate(-135.35)"
  })), _text219 || (_text219 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.7, -0.71, 0.71, -0.7, 176.79, 541.13)"
  })), _text220 || (_text220 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.69, -0.72, 0.72, -0.69, 175, 539.3)"
  })), _text221 || (_text221 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.68, -0.73, 0.73, -0.68, 173.23, 537.45)"
  })), _text222 || (_text222 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.66, -0.75, 0.75, -0.66, 171.48, 535.58)"
  }, "2")), _text223 || (_text223 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.65, -0.76, 0.76, -0.65, 168.52, 532.25)"
  }, "3")), _text224 || (_text224 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(165.67 528.88) rotate(-128.7)"
  }, "0")), _text225 || (_text225 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.61, -0.79, 0.79, -0.61, 162.91, 525.42)"
  })), _text226 || (_text226 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.6, -0.8, 0.8, -0.6, 161.35, 523.38)"
  })), _text227 || (_text227 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.58, -0.81, 0.81, -0.58, 159.82, 521.33)"
  })), _text228 || (_text228 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(158.31 519.25) rotate(-124.92)"
  })), _text229 || (_text229 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(156.84 517.14) rotate(-124.06)"
  })), _text230 || (_text230 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.55, -0.84, 0.84, -0.55, 155.4, 515.01)"
  })), _text231 || (_text231 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(153.98 512.87) rotate(-122.06)"
  }, "2")), _text232 || (_text232 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(151.63 509.1) rotate(-120.57)"
  }, "4")), _text233 || (_text233 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(149.38 505.3) rotate(-119.09)"
  }, "0")), _text234 || (_text234 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(147.23 501.41) rotate(-117.87)"
  })), _text235 || (_text235 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.45, -0.89, 0.89, -0.45, 146.03, 499.16)"
  })), _text236 || (_text236 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(144.87 496.88) rotate(-116.15)"
  })), _text237 || (_text237 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.43, -0.9, 0.9, -0.43, 143.73, 494.56)"
  })), _text238 || (_text238 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(142.63 492.24) rotate(-114.42)"
  })), _text239 || (_text239 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(141.57 489.91) rotate(-113.55)"
  })), _text240 || (_text240 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(140.55 487.56) rotate(-112.69)"
  })), _text241 || (_text241 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(139.54 485.18) rotate(-111.53)"
  }, "2")), _text242 || (_text242 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(137.91 481.06) rotate(-110.03)"
  }, "5")), _text243 || (_text243 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(136.4 476.91) rotate(-108.54)"
  }, "0")), _text244 || (_text244 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(135 472.7) rotate(-107.32)"
  })), _text245 || (_text245 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(134.24 470.26) rotate(-106.46)"
  })), _text246 || (_text246 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.27, -0.96, 0.96, -0.27, 133.51, 467.8)"
  })), _text247 || (_text247 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(132.81 465.32) rotate(-104.72)"
  })), _text248 || (_text248 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(132.16 462.83) rotate(-103.85)"
  })), _text249 || (_text249 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(131.55 460.36) rotate(-102.99)"
  })), _text250 || (_text250 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.21, -0.98, 0.98, -0.21, 130.96, 457.84)"
  }, "2")), _text251 || (_text251 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.18, -0.98, 0.98, -0.18, 130.05, 453.51)"
  }, "6")), _text252 || (_text252 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(-0.15, -0.99, 0.99, -0.15, 129.26, 449.17)"
  }, "0")), _text253 || (_text253 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(128.58 444.77) rotate(-97.64)"
  })), _text254 || (_text254 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(128.24 442.23) rotate(-96.78)"
  })), _text255 || (_text255 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.1, -0.99, 0.99, -0.1, 127.93, 439.69)"
  })), _text256 || (_text256 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.09, -1, 1, -0.09, 127.67, 437.13)"
  })), _text257 || (_text257 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.07, -1, 1, -0.07, 127.44, 434.56)"
  })), _text258 || (_text258 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(127.25 432.01) rotate(-93.35)"
  })), _text259 || (_text259 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(127.1 429.46) rotate(-92.51)"
  })), _text260 || (_text260 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(126.97 426.88) rotate(-91.38)"
  }, "2")), _text261 || (_text261 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(126.83 422.45) rotate(-89.07)"
  }, "7")), _text262 || (_text262 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(126.87 418.02) rotate(-88.46)"
  }, "0")), _text263 || (_text263 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(127 413.59) rotate(-87.27)"
  })), _text264 || (_text264 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(127.12 411.04) rotate(-86.42)"
  })), _text265 || (_text265 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.08, -1, 1, 0.08, 127.28, 408.46)"
  })), _text266 || (_text266 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.09, -1, 1, 0.09, 127.48, 405.92)"
  })), _text267 || (_text267 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(127.71 403.37) rotate(-83.85)"
  })), _text268 || (_text268 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(127.99 400.82) rotate(-82.99)"
  })), _text269 || (_text269 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(128.29 398.26) rotate(-81.85)"
  }, "2")), _text270 || (_text270 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(128.92 393.87) rotate(-80.36)"
  }, "8")), _text271 || (_text271 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(129.66 389.49) rotate(-78.86)"
  }, "0")), _text272 || (_text272 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.21, -0.98, 0.98, 0.21, 130.52, 385.16)"
  })), _text273 || (_text273 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(131.07 382.66) rotate(-76.79)"
  })), _text274 || (_text274 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.24, -0.97, 0.97, 0.24, 131.66, 380.15)"
  })), _text275 || (_text275 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(132.28 377.66) rotate(-75.05)"
  })), _text276 || (_text276 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(132.94 375.17) rotate(-74.18)"
  })), _text277 || (_text277 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.29, -0.96, 0.96, 0.29, 133.64, 372.71)"
  })), _text278 || (_text278 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(134.36 370.26) rotate(-72.17)"
  }, "2")), _text279 || (_text279 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.33, -0.94, 0.94, 0.33, 135.72, 366.03)"
  }, "9")), _text280 || (_text280 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.36, -0.93, 0.93, 0.36, 137.18, 361.87)"
  }, "0")), _text281 || (_text281 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(138.77 357.72) rotate(-67.95)"
  })), _text282 || (_text282 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(139.73 355.33) rotate(-67.08)"
  })), _text283 || (_text283 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(140.73 352.97) rotate(-66.22)"
  })), _text284 || (_text284 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(141.76 350.63) rotate(-65.35)"
  })), _text285 || (_text285 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.43, -0.9, 0.9, 0.43, 142.83, 348.3)"
  })), _text286 || (_text286 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(143.94 345.96) rotate(-63.62)"
  })), _text287 || (_text287 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.46, -0.89, 0.89, 0.46, 145.08, 343.67)"
  })), _text288 || (_text288 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(146.24 341.4) rotate(-61.62)"
  }, "3")), _text289 || (_text289 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(148.35 337.48) rotate(-60.12)"
  }, "0")), _text290 || (_text290 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(150.55 333.66) rotate(-58.64)"
  }, "0")), _text291 || (_text291 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(152.86 329.87) rotate(-57.43)"
  })), _text292 || (_text292 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(154.25 327.71) rotate(-56.57)"
  })), _text293 || (_text293 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.56, -0.83, 0.83, 0.56, 155.66, 325.56)"
  })), _text294 || (_text294 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(157.11 323.44) rotate(-54.85)"
  })), _text295 || (_text295 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.59, -0.81, 0.81, 0.59, 158.58, 321.34)"
  })), _text296 || (_text296 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(160.09 319.26) rotate(-53.13)"
  })), _text297 || (_text297 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.62, -0.79, 0.79, 0.62, 161.62, 317.2)"
  }, "3")), _text298 || (_text298 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(164.34 313.72) rotate(-50.52)"
  }, "1")), _text299 || (_text299 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.66, -0.76, 0.76, 0.66, 167.17, 310.28)"
  }, "0")), _text300 || (_text300 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(170.08 306.95) rotate(-47.84)"
  })), _text301 || (_text301 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(171.79 305.05) rotate(-46.98)"
  })), _text302 || (_text302 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(173.54 303.18) rotate(-46.13)"
  })), _text303 || (_text303 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(175.33 301.31) rotate(-45.27)"
  })), _text304 || (_text304 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(177.13 299.49) rotate(-44.41)"
  })), _text305 || (_text305 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.72, -0.69, 0.69, 0.72, 178.96, 297.7)"
  })), _text306 || (_text306 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(180.82 295.93) rotate(-42.71)"
  })), _text307 || (_text307 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(182.71 294.17) rotate(-41.56)"
  }, "3")), _text308 || (_text308 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(186.02 291.24) rotate(-40.09)"
  }, "2")), _text309 || (_text309 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(189.4 288.39) rotate(-38.61)"
  }, "0")), _text310 || (_text310 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.79, -0.61, 0.61, 0.79, 192.86, 285.64)"
  })), _text311 || (_text311 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(194.9 284.08) rotate(-36.56)"
  })), _text312 || (_text312 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.81, -0.58, 0.58, 0.81, 196.98, 282.53)"
  })), _text313 || (_text313 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(199.07 281.03) rotate(-34.83)"
  })), _text314 || (_text314 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.83, -0.56, 0.56, 0.83, 201.18, 279.56)"
  })), _text315 || (_text315 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(203.28 278.14) rotate(-33.12)"
  })), _text316 || (_text316 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.85, -0.53, 0.53, 0.85, 205.43, 276.73)"
  }, "3")), _text317 || (_text317 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.86, -0.51, 0.51, 0.86, 209.2, 274.37)"
  }, "3")), _text318 || (_text318 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.87, -0.48, 0.48, 0.87, 213, 272.13)"
  }, "0")), _text319 || (_text319 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(216.9 269.99) rotate(-27.78)"
  })), _text320 || (_text320 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(219.15 268.79) rotate(-26.93)"
  })), _text321 || (_text321 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(221.46 267.62) rotate(-26.05)"
  })), _text322 || (_text322 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(223.76 266.5) rotate(-25.19)"
  })), _text323 || (_text323 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.91, -0.41, 0.41, 0.91, 226.07, 265.41)"
  })), _text324 || (_text324 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(228.41 264.35) rotate(-23.46)"
  })), _text325 || (_text325 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(230.76 263.32) rotate(-22.6)"
  })), _text326 || (_text326 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(233.14 262.32) rotate(-21.44)"
  }, "3")), _text327 || (_text327 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "matrix(0.94, -0.34, 0.34, 0.94, 237.27, 260.7)"
  }, "4")), _text328 || (_text328 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(241.42 259.2) rotate(-18.45)"
  }, "0")), _text329 || (_text329 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.96, -0.3, 0.3, 0.96, 245.63, 257.8)"
  })), _text330 || (_text330 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(248.07 257.04) rotate(-16.37)"
  })), _text331 || (_text331 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(250.54 256.31) rotate(-15.5)"
  })), _text332 || (_text332 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(253.01 255.63) rotate(-14.63)"
  })), _text333 || (_text333 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(255.51 254.97) rotate(-13.76)"
  })), _text334 || (_text334 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.97, -0.22, 0.22, 0.97, 257.98, 254.37)"
  })), _text335 || (_text335 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(260.5 253.78) rotate(-11.74)"
  }, "3")), _text336 || (_text336 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(264.83 252.88) rotate(-10.25)"
  }, "5")), _text337 || (_text337 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_10",
    transform: "translate(269.17 252.09) rotate(-8.77)"
  }, "0")), _text338 || (_text338 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(294.23 262.18) rotate(0.93)"
  }, "N")), _text339 || (_text339 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(301.41 262.28) rotate(1.85)"
  })), _text340 || (_text340 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(327.56 265.06) rotate(11.35)"
  })), _text341 || (_text341 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.92, 0.4, -0.4, 0.92, 359.5, 274.8)"
  })), _text342 || (_text342 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.81, 0.58, -0.58, 0.81, 388.65, 291.04)"
  })), _text343 || (_text343 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(390.88 292.63) rotate(36.66)"
  })), _text344 || (_text344 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(393.09 294.28) rotate(37.66)"
  })), _text345 || (_text345 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.78, 0.62, -0.62, 0.78, 395.26, 295.95)"
  })), _text346 || (_text346 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(397.41 297.68) rotate(39.64)"
  })), _text347 || (_text347 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.76, 0.65, -0.65, 0.76, 399.54, 299.44)"
  })), _text348 || (_text348 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.75, 0.66, -0.66, 0.75, 401.61, 301.21)"
  })), _text349 || (_text349 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.74, 0.68, -0.68, 0.74, 403.68, 303.05)"
  })), _text350 || (_text350 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(405.71 304.87) rotate(44.39)"
  }, "N")), _text351 || (_text351 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(410.81 309.87) rotate(46.76)"
  }, "E")), _text352 || (_text352 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(414.94 314.3) rotate(48.34)"
  })), _text353 || (_text353 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.5, 0.86, -0.86, 0.5, 433.76, 339.79)"
  })), _text354 || (_text354 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(447.67 370.13) rotate(71.97)"
  })), _text355 || (_text355 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(454.86 402.73) rotate(84.13)"
  })), _text356 || (_text356 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.17 405.73) rotate(85.22)"
  })), _text357 || (_text357 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.42 408.71) rotate(86.29)"
  })), _text358 || (_text358 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.61 411.71) rotate(87.37)"
  })), _text359 || (_text359 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.03, 1, -1, 0.03, 455.75, 414.72)"
  })), _text360 || (_text360 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.89 417.68) rotate(90.93)"
  }, "E")), _text361 || (_text361 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.81 423.76) rotate(91.66)"
  })), _text362 || (_text362 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(455.08 436.12) rotate(96.1)"
  })), _text363 || (_text363 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.31, 0.95, -0.95, -0.31, 448.33, 468.82)"
  })), _text364 || (_text364 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(434.83 499.34) rotate(120.44)"
  })), _text365 || (_text365 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.68, 0.73, -0.73, -0.68, 415.24, 526.37)"
  }, "S")), _text366 || (_text366 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(410.85 531.04) rotate(135.42)"
  }, "E")), _text367 || (_text367 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.73, 0.68, -0.68, -0.73, 406.52, 535.28)"
  })), _text368 || (_text368 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(390.39 548.69) rotate(144.56)"
  })), _text369 || (_text369 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.92, 0.4, -0.4, -0.92, 361.44, 565.32)"
  })), _text370 || (_text370 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.98, 0.19, -0.19, -0.98, 329.65, 575.48)"
  })), _text371 || (_text371 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(327.1 575.98) rotate(169.83)"
  })), _text372 || (_text372 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.99, 0.16, -0.16, -0.99, 324.54, 576.44)"
  })), _text373 || (_text373 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(322 576.86) rotate(171.71)"
  })), _text374 || (_text374 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.99, 0.13, -0.13, -0.99, 319.44, 577.23)"
  })), _text375 || (_text375 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(316.87 577.56) rotate(173.58)"
  })), _text376 || (_text376 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(314.29 577.86) rotate(174.52)"
  })), _text377 || (_text377 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(311.7 578.11) rotate(175.46)"
  })), _text378 || (_text378 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, 0.06, -0.06, -1, 309.12, 578.31)"
  })), _text379 || (_text379 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, 0.05, -0.05, -1, 306.53, 578.48)"
  })), _text380 || (_text380 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-1, 0.03, -0.03, -1, 303.96, 578.6)"
  })), _text381 || (_text381 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(301.39 578.67) rotate(179.07)"
  }, "S")), _text382 || (_text382 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(294.94 578.71) rotate(-178.56)"
  })), _text383 || (_text383 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(263.22 574.98) rotate(-167)"
  })), _text384 || (_text384 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(231.58 564.34) rotate(-154.81)"
  })), _text385 || (_text385 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.8, -0.61, 0.61, -0.8, 202.89, 547.27)"
  })), _text386 || (_text386 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.78, -0.62, 0.62, -0.78, 200.72, 545.61)"
  })), _text387 || (_text387 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.77, -0.63, 0.63, -0.77, 198.55, 543.9)"
  })), _text388 || (_text388 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(196.43 542.17) rotate(-139.73)"
  })), _text389 || (_text389 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.75, -0.66, 0.66, -0.75, 194.33, 540.39)"
  })), _text390 || (_text390 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(-0.73, -0.68, 0.68, -0.73, 192.27, 538.61)"
  }, "S")), _text391 || (_text391 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(187.54 534.27) rotate(-134.28)"
  }, "W")), _text392 || (_text392 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(181.18 527.67) rotate(-132.15)"
  })), _text393 || (_text393 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(178.41 524.57) rotate(-130.65)"
  })), _text394 || (_text394 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(159.2 497.26) rotate(-118.57)"
  })), _text395 || (_text395 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(146.16 466.54) rotate(-106.39)"
  })), _text396 || (_text396 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(139.9 433.76) rotate(-94.25)"
  })), _text397 || (_text397 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(139.7 430.99) rotate(-93.25)"
  })), _text398 || (_text398 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(139.54 428.27) rotate(-92.28)"
  })), _text399 || (_text399 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(139.43 425.56) rotate(-90.93)"
  }, "W")), _text400 || (_text400 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(139.41 416.35) rotate(-88.04)"
  })), _text401 || (_text401 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(140.62 400.37) rotate(-82.27)"
  })), _text402 || (_text402 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 148.31, 367.86)"
  })), _text403 || (_text403 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.53, -0.85, 0.85, 0.53, 162.67, 337.75)"
  })), _text404 || (_text404 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.55, -0.84, 0.84, 0.55, 164.15, 335.4)"
  })), _text405 || (_text405 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(165.64 333.11) rotate(-55.94)"
  })), _text406 || (_text406 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(167.17 330.84) rotate(-54.95)"
  })), _text407 || (_text407 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.59, -0.81, 0.81, 0.59, 168.76, 328.58)"
  })), _text408 || (_text408 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(170.37 326.36) rotate(-52.96)"
  })), _text409 || (_text409 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.62, -0.79, 0.79, 0.62, 172.03, 324.16)"
  })), _text410 || (_text410 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(173.72 322.01) rotate(-50.98)"
  })), _text411 || (_text411 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(175.46 319.86) rotate(-49.99)"
  })), _text412 || (_text412 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(177.23 317.75) rotate(-48.99)"
  })), _text413 || (_text413 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "matrix(0.68, -0.73, 0.73, 0.68, 178.98, 315.68)"
  }, "N")), _text414 || (_text414 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_8",
    transform: "translate(183.81 310.42) rotate(-44.28)"
  }, "W")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.33 302.3l-1.77-6.39 6.41 1.67-4.64 4.72zM420.97 537.95l1.76 6.39-6.41-1.67 4.65-4.72zM415.76 296.58l6.4-1.72-1.71 6.4-4.69-4.68zM179.8 543.67l-6.4 1.72 1.71-6.4 4.69 4.68z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5RearDisk);
export default __webpack_public_path__ + "static/media/crp5-rear-disk.cc44813caf6d2e8400f4803ff64756cd.svg";
export { ForwardRef as ReactComponent };